import type { VaasThumbnail } from "~/v2/types/vaas"

const getCloudinaryThumbnailUrl = (
  thumbnail?: VaasThumbnail | null,
  size = 280,
): string | null => {
  if (!thumbnail?.public_id) {
    return null
  }

  const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME
  const format = thumbnail.format === "jpg" ? "jpg" : thumbnail.format || "jpg"

  return `https://res.cloudinary.com/${cloudName}/image/upload/c_fill,ar_16:9,g_auto,w_${size}/f_${format}/${thumbnail.public_id}.${format}`
}

export default getCloudinaryThumbnailUrl
